export default __webpack_public_path__ + "static/HappyBirthdayTemplate-af490a1d84fa64271d448f6d0559ad34.png";